import React, { useEffect, useState } from "react"
import { Form, Row, Col, Select, message } from 'antd';
import Input from "../../../../ui/Input"
import ActionButtonsBar from "../../../../ui/ActionButtonsBar"
import styles from '../../index.module.css'
import { getUOMlist, getAllData, SaveClick, validateFieldsError } from './helper'

const { Option } = Select;

const General = (props: any) => {
  const [form] = Form.useForm()
  const [uomList, setUomList] = useState([])
  const [disabledStatus, setDisabledStatus] = useState<boolean>(false)
  const [booleanOptions] = useState(['Yes', 'No'])

  useEffect(() => {
      getAllData(form, props)
      getUOMlist(setUomList)
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [])

  const onSave = () => {
    return SaveClick(form, props, message)
  }

  const onCancel = () => {
    getAllData(form, props)
  }

  const validateError = (changedValues: any, allValues: any) => {
    return validateFieldsError(changedValues, allValues, form, setDisabledStatus)
  }

  return (
    <div className={props.editFlag ? styles.generalCon : styles.generalEdit}>
      <Form
        layout='vertical'
        form={form}
        name='basic'
        initialValues={{ remember: true }}
        onValuesChange={validateError}>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Total Meeting Rooms'
              name='totalcount'
              rules={[
                {
                  required: false,
                  pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='Unit of Measure' name='uom'>
              <Select allowClear showSearch>
                {uomList.map((item: any) => {
                  return (
                    <Option key={item.codeName} value={item.codeName}>
                      {item.codeName}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>  
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Smallest Meeting  Space'
              name='smallestmeetingspace'
              rules={[
                {
                  pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='Largest Meeting Space'
              name='largestmeetingspace'
              rules={[
                {
                  pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              label='Total Meeting Space'
              name='totalmeetingspace'
              rules={[
                {
                  pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Exhibit Space'
              name='exhibitspace'>
              <Select allowClear showSearch>
                {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='Total Exhibit Space'
              name='totalexhibitspace'
              rules={[
                {
                  pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Conference Space'
              name='conferencespace'>
              <Select allowClear showSearch>
                {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='Conference Coordinator on Site'
              name='confcoordinator'>
              <Select allowClear showSearch>
                {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Smallest Room Seating Capacity'
              name='smallestroomseatingcapacity'
              rules={[
                {
                  required: false,
                  pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='Largest Room Seating Capacity'
              name='largestroomseatingcapacity'
              rules={[
                {
                  required: false,
                  pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              label='Total Room Seating Capacity'
              name='totalroomseatingcapacity'
              rules={[
                {
                  required: false,
                  pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Boardroom'
              name='boardroom'>
              <Select allowClear showSearch>
                {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='Boardroom Seating Capacity'
              name='boardroomseatingcapacity'
              rules={[
                {
                  required: false,
                  pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                  message: 'This field should be a number',
                },
                () => ({
                  validator(_, value) {
                    /* if (!value) {
                      return Promise.reject();
                    }
                    if (isNaN(value)) {
                      return Promise.reject("This field should be a number");
                    } */
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (value.length > 8) {
                      return Promise.reject("You have reached the max character length of 8");
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              >
              <Input maxLength={props.editFlag ? 8 : 0}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Maximum Cost for 10 Person Breakout Room'
              name='maxcost10breakoutroom'
              rules={[
                {
                  required: false,
                  pattern: /^\d*(\.\d*)?$/,
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='Maximum Cost for 25 Person Breakout Room'
              name='maxcost25breakoutroom'
              rules={[
                {
                  required: false,
                  pattern: /^\d*(\.\d*)?$/,
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Convention Facilities'
              name='conventionfacilities'>
              <Select allowClear showSearch>
                {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='Host Social Functions'
              name='hostsocialfunctions'>
              <Select allowClear showSearch>
                {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Number of Meeting Personnel on Property'
              name='numberofmeetingpersonnelonproperty'
              rules={[
                {
                  required: false,
                  pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                  message: 'This field should be a number',
                },
                () => ({
                  validator(_, value) {
                    /* if (!value) {
                      return Promise.reject();
                    }
                    if (isNaN(value)) {
                      return Promise.reject("This field should be a number");
                    } */
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (value.length > 5) {
                      return Promise.reject("You have reached the max character length of 5");
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              >
              <Input maxLength={props.editFlag ? 5 : 0}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='Complimentary Parking for Meeting Attendees'
              name='complimentaryparking'>
              <Select allowClear showSearch>
              {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Catering'
              name='catering'>
              <Select allowClear showSearch>
              {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='Guaranteed Discount off Food & Beverage Charges'
              name='guaranteeddiscountfood'>
              <Select allowClear showSearch>
                {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Banquet Service Charge Pct'
              name='banquetservicechargepct'
              rules={[
                {
                  required: false,
                  pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                  message: 'This field should be a number',
                },
                () => ({
                  validator(_, value) {
                    /* if (!value) {
                      return Promise.reject();
                    }
                    if (isNaN(value)) {
                      return Promise.reject("This field should be a number");
                    } */
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (value.length > 5) {
                      return Promise.reject("You have reached the max character length of 5");
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              >
              <Input maxLength={props.editFlag ? 5 : 0}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='Banquet Service Charges Taxed'
              name='banquetservicechargestaxed'>
              <Select allowClear showSearch>
                {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label='Actualized Room Number For Complimentary Room'
              name='actualroomforcomplimentaryroom'
              rules={[
                {
                  required: false,
                  pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                  message: 'This field should be a number',
                },
              ]}>
              <Input/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label='Rooms associated to meeting but outside of room block will apply towards room block performance clause'
              name='roomsassociatedtomeetingbutoutsideofroomblockwillapplytowardsroomblockperformanceclause'>
              <Select allowClear showSearch>
                {
                  booleanOptions.map((option, i) => (
                    <Option key={i} value={option}>
                      {option}
                    </Option>
                  ))
                }
              </Select>
            </Form.Item>
          </Col>
        </Row>

      </Form>
      {
        props.editFlag && <ActionButtonsBar
          onCancel={() => {
            props.setEditFlag(false)
            window.cancelEdition()
            props.setOneNavDisabled(false)
            onCancel()
          }}
          onSave={onSave}
          disabledSave={disabledStatus}
          warningMsg={true}
        />
      }
    </div>
  )
}

export default General
